var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCloudFooter = function SvgCloudFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 768 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 190h768v-28.499s-22.289-27.705-45.547-38.119C681.029 91.982 584.5 137 584.5 137s-4.5-22-10.817-34.258l-.387-.467c-6.589-7.937-14.598-17.584-26.978-20.6-13.973-3.405-36.985 5.266-36.985 5.266s-38.431-65.44-102.347-82.055c-63.917-16.614-122.574 21.746-126.514 45.025-47.452-25.693-79.684-.04-101.156 17.05l-.049.04c-12.722-33.751-55.928-73-151.303 3.5C19.24 56.061 8.687 57.585 0 64.44V190Z",
    fill: "currentColor"
  })));
};

export default SvgCloudFooter;